import { createSessionStorageSync } from './use-session-storage-sync'

export type RecurringTab = 'monthly' | 'yearly'

// タブはセッション内の「今の文脈」 として sessionStorage で保持。
// ブラウザを閉じたらリセットし、 次回起動時は monthly (デフォルト) から始まる。
export const useRecurringTab = createSessionStorageSync<RecurringTab>(
  'tab.recurring',
  'monthly',
  (raw) => (raw === 'monthly' || raw === 'yearly' ? raw : null),
)
